module.exports = __webpack_public_path__ + "static/product_6_month-2576e640ea17acef7f67a3a707c6b165.png";